var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStickyNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sticky_note_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5488 5.80609V14.6894H14.5488V19.6245H5.54883V5.80609H19.5488ZM19.5488 3.83203H5.54883C4.44883 3.83203 3.54883 4.72036 3.54883 5.80609V19.6245C3.54883 20.7103 4.44883 21.5986 5.54883 21.5986H15.5488L21.5488 15.6764V5.80609C21.5488 4.72036 20.6488 3.83203 19.5488 3.83203ZM12.5488 14.6894H7.54883V12.7153H12.5488V14.6894ZM17.5488 10.7413H7.54883V8.76719H17.5488V10.7413Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyNotes);
export default __webpack_public_path__ + "static/media/sticky_notes.b3127b5233a4f7d1d3dd9bb086d3673c.svg";
export { ForwardRef as ReactComponent };